// extracted by mini-css-extract-plugin
export default {"heading":"index_heading__utn7M","simpleParagraph":"index_simpleParagraph__U8RW4"};